import React,{ useEffect, useState } from 'react';
import { history, useLocation } from 'umi';
import {Page } from 'react-weui';
import { Toast } from 'antd-mobile';
import styles from '../myPoint/styles.scss';

import { getMyFiruit } from '@/services/myself';

export default (props) => {
  const user = props.location.state.user;

  const [dataList, setDataList] = useState([]);

  const typeArr = ['日常收取', '积分兑换', '抽奖消耗', '兑换课程','抽奖获取'];


  useEffect(() => {
    Toast.loading('loading',60);
    getMyFiruit().then(res => {
      console.log(res);
      Toast.hide();
      if (res && res.code == 200) {
        setDataList(res.data);
      }else {
        Toast.fail('获取失败，请重试');
      }
    }).catch(e=>{
      Toast.hide();
      Toast.fail('获取失败，请重试');
    });
  }, []);


  return (
    <Page transition={true} infiniteLoader={false} ptr={false}>

      <div className={styles.header}>
        <label className={styles.labelTitle}>当前果实</label>
        <label className={styles.labelValue}>{user.fruit}</label>
      </div>

      <div className={styles.box}>
        <div className={styles.boxTitle}>果实简介</div>
        <div className={styles.boxDesc}>果实是基于个人在果园活动产生的奖励，可以用于果园的消费与兑换等。</div>
      </div>

      <div className={styles.box}>
        <div className={styles.boxTitle}>收支记录 <label>最多显示20条记录</label></div>

        {dataList.map((item,i) =>(
          <div className={styles.recordItem} key={i+''}>
            <label className={styles.itemTitle}>{typeArr[item.fruitType]}</label>
            <label className={styles.itemTime}>{item.collectTime}</label>
            <label className={styles.itemValue}
                   style={{'color': item.fruitSize >= 0 ? '#57B99D' : 'red'}}>
              {item.fruitSize >= 0 ? '+' : ''}{item.fruitSize}</label>
          </div>
        ))}

      </div>
    </Page>
  )
}
